import { render, staticRenderFns } from "./FloorGoods.vue?vue&type=template&id=33a10a78&scoped=true"
import script from "./FloorGoods.vue?vue&type=script&lang=js"
export * from "./FloorGoods.vue?vue&type=script&lang=js"
import style0 from "./FloorGoods.vue?vue&type=style&index=0&id=33a10a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a10a78",
  null
  
)

export default component.exports